import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const API_URL = environment.apiBaseLink + '/api/setting/';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  // Inject
  private readonly httpClient = inject(HttpClient);

  /**
   * getSetting()
   * getPaymentMethod()
   * getDeliveryCharge()
   * getChatLink()
   */

  getSetting(select?: string) {
    let params = new HttpParams();
    if (select) {
      params = params.append('select', select);
    }
    return this.httpClient.get<{
      data: any,
      message: string,
      success: boolean
    }>(API_URL + 'get', { params });
  }

  getPaymentMethod() {
    return this.httpClient.get<{
      data: any,
      message: string,
      success: boolean
    }>(API_URL + 'get-payment-methods');
  }

  getDeliveryCharge() {
    return this.httpClient.get<{
      data: any[],
      message: string,
      success: boolean
    }>(API_URL + 'get-delivery-charges');
  }

  getChatLink() {
    return this.httpClient.get<{
      data: any,
      message: string,
      success: boolean
    }>(API_URL + 'get-chat-link');
  }

  getSocialLogins() {
    return this.httpClient.get<{
      data: any[],
      message: string,
      success: boolean
    }>(API_URL + 'get-social-logins');
  }

}
